import { gql } from "@apollo/client";

export const INVOICE_PREVIEW_QUERY = gql`
  query InvoicePreviewDetails($invoice: ID!) {
    invoiceDetails(invoice: $invoice) {
      id
      referenceId
      invoiceId
      total
      subtotal
      tax
      taxPercent
      discount
      discountPercent
      diagnosticFee
      insurance
      patientPart
      paid
      paidInFull
      pendingPayment
      pendingPaymentPercent
      preAuth
      details
      balanceInvoice
      signed
      signedAt
      released
      releasedAt
      createdAt
      updatedAt
      patient {
        id
        firstName
        lastName
        birthDate
        patientId
        referenceId
        phoneNumber
        nationalId
        nationality
        insuranceNumber
      }
      doctor {
        id
        name
        medicalNumber
      }
      branch {
        id
        name
      }
      insuranceCompany {
        id
        name
      }
      insurancePolicy {
        id
        policyNumber
        holderName
      }
      policyClass {
        id
        name
      }
      payments {
        id
        amount
        type
        refunded
        createdAt
      }
      operations {
        id
        name
        code
        price
        amount
        discount
        insurance
        tax
        status
        doctor {
          id
          name
          medicalNumber
        }
      }
      users {
        id
        name
      }
      createdBy {
        id
        name
      }
      signedBy {
        id
        name
      }
      releasedBy {
        id
        name
      }
      eInvoiceStatus
      insuranceEInvoiceStatus
      claim {
        id
        name
        referenceId
        activeClaimInvoice {
          id
          number
          status
        }
      }
    }
  }
`;

